import { FlatItem } from 'src/types/elements.type';
import { FuelConsumptionAdd, IFuelConsumption } from 'src/types/master_data/fuelConsumption.type';
import { http } from '@martech-solution/utils/utils';

const controller = 'master-data/fuel-consumptions';

export const getFuelConsumptions = async () => {
  return await http.get<IFuelConsumption[]>(controller);
};

export const getFuelConsumption = async (id: number | undefined) => {
  return http.get<IFuelConsumption>(`${controller}/${id}`);
};

export const getTotalFuelConsumptionByDistance = async (vehicleType?: number, distance?: number) => {
  return http.get<number>(`${controller}/get-total-by-distance`, {
    params: {
      vehicleType: vehicleType,
      distance: distance
    }
  });
};

export const addFuelConsumption = async (fuelConsumption: FuelConsumptionAdd) => {
  return http.post<IFuelConsumption>(controller, fuelConsumption);
};

export const updateFuelConsumption = async (id: number, fuelConsumption: IFuelConsumption) => {
  return await http.put<IFuelConsumption[]>(`${controller}/${id}`, fuelConsumption);
};

export const deleteFuelConsumption = async (id: number) => {
  return await http.delete(`${controller}/${id}`);
};

export const getFuelConsumptionsDropdown = async () => {
  return await http.get<FlatItem[]>(`${controller}/dropdown`);
};
